/* eslint-disable react/prop-types */
// Default imports
import React, { useState } from 'react';

// Spectrum
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';

// Lodash
import _ from 'lodash';

// Styles
import styles from './css/Accordion.module.scss';

const Accordion = ({
  isOpen = false,
  borderStyle,
  title,
  metadata,
  children,
  className,
}) => {
  // Use state hook to manage the open/closed state of the accordion
  const [open, setOpen] = useState(isOpen);

  /**
   * toggleAccordion
   * Toggles the accordion open/closed state.
   * @param e - Event (optional - for keypress events)
   */
  const toggleAccordion = (e) => {
    // Handle keydown events.
    // We only want to act on space, enter, left, right, and down arrows.
    if (e && e.type === 'keydown' && !_.includes([32, 13, 37, 39, 40], e.keyCode)) {
      return;
    }

    // Toggle the open/close state
    setOpen((prevState) => !prevState);
  };

  return (
    <div className={`${styles.container} ${borderStyle === 'none' ? styles.none : ''} ${className}`}>
      <div aria-label="accordion" className={styles.infoContainer} role="button" tabIndex={0} onClick={toggleAccordion} onKeyDown={toggleAccordion}>
        <div className={styles.title}>
          {title}
        </div>
        {metadata && (
          <div
            className={styles.metadata}
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); }}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.stopPropagation(); }}
          >
            {metadata}
          </div>
        )}
        <div className={`${styles.arrow} ${open ? styles.isOpen : ''}`}>
          <ChevronRight size="M" />
        </div>
      </div>
      <div className={`${styles.content} ${open ? styles.isOpen : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
